// extracted by mini-css-extract-plugin
export var badges = "Mobile-module--badges--dce10";
export var btn = "Mobile-module--btn--dbe65";
export var btnOutlinePrimary = "Mobile-module--btn-outline-primary--d90ce";
export var btnPrimary = "Mobile-module--btn-primary--9f6ac";
export var content = "Mobile-module--content--c51b0";
export var formSelect = "Mobile-module--form-select--492ec";
export var heading = "Mobile-module--heading--5452e";
export var inner = "Mobile-module--inner--d735a";
export var lead = "Mobile-module--lead--c3dbb";
export var media = "Mobile-module--media--54511";
export var section = "Mobile-module--section--52e92";
export var text = "Mobile-module--text--59adc";